<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import { systemUrl } from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import ToolTip from './ToolTip.svelte'; 
    export let locations = [];
    
</script>

<div class="table table-shipments">
    <div class="head">
        <div>{$_('locations.enabled')}</div>
        <div>{$_('locations.name')} <ToolTip text={$_('locations.explain_name')}></ToolTip></div>
        <div>{$_('locations.label')} <ToolTip text={$_('locations.explain_label')}></ToolTip></div>
        <div>{$_('locations.city')}</div>
        <div>{$_('locations.street')}</div>
        <div>{$_('locations.house')}</div>
        <div>{$_('locations.phone')}</div>
        <div>{$_('locations.email')}</div>
        <div></div>
    </div>
    {#each locations as item,index}
    <div class="content">
        <div class="input_con radio checkbox-toggle radio-width">            
            <input id="enabled{index}" type="checkbox" bind:value={item.enabled} bind:checked={item.enabled}>       
            <label for="enabled{index}"><span></span></label>     
        </div>
        <div class="input_con">
            <label class="mobile">{$_('locations.name')}</label>
            <input type="text" bind:value={item.name}>
        </div>
        <div class="input_con">
            <label class="mobile">{$_('locations.label')}</label>
            <input type="text" bind:value={item.label}>
        </div>
        <div class="input_con">
            <label class="mobile">{$_('locations.city')}</label>
            <input type="text" bind:value={item.city}>
        </div>
        <div class="input_con">
            <label class="mobile">{$_('locations.street')}</label>
            <input type="text" bind:value={item.street}>
        </div>
        <div class="input_con">
            <label class="mobile">{$_('locations.house')}</label>
            <input type="text" bind:value={item.house}>
        </div>
        <div class="input_con">
            <label class="mobile">{$_('locations.phone')}</label>
            <input type="text" bind:value={item.phone}>
        </div>
        <div class="input_con">
            <label class="mobile">{$_('locations.email')}</label>
            <input type="text" bind:value={item.email}>
        </div>
        <div on:click={()=> { locations.splice(index, 1); locations = locations; }}><i class="fa-solid fa-trash"></i></div>
    </div>
    {/each}
</div>
<style>
.radio-width {
    width:50px;
}
.content {
    vertical-align: middle;
}

</style>